export default __webpack_public_path__ + "static/media/20.78d7d81b.png";